import {
  FormBuilderMetaFlags,
  IWidgetDirectiveType,
  WidgetType,
  isInputWidget,
} from '@framework/engine';
import {
  IMetadataDirective,
  IMetadataDirectiveSchemaMeta,
  MetadataDirectiveSchema,
} from './IMetadataDirective';
import { MetadataDirectiveConfigComponent } from './MetadataDirectiveConfigComponent';

/**
 * Flag che permette di forzare l'esportazione dei metadati di un campo, anche
 * in caso di flag di validazione disabilitati.
 * È il caso dei metadati dei Widget Mappa, che devono essere sempre esportati,
 * anche se sono campi "custom" a cui non vengono applicate le regole di
 * validazione (es. obbligatorietà).
 */
export const FormBuilderMetaFlagExportMetadata = 'formBuilder@ExportMetadata';

/**
 * Direttiva per l'esportazione dei metadati di un campo in forma
 * normalizzata.
 */
export const MetadataDirectiveType: IWidgetDirectiveType<IMetadataDirective> = {
  name: 'metadata',
  key: 'metadata',
  allowsWidget: (widget, widgetType) =>
    isInputWidget(widget) && widget.type !== WidgetType.Repeatable,
  configComponent: MetadataDirectiveConfigComponent,
  configSchema: MetadataDirectiveSchema,
  formSchemaModifier: ({
    directiveConfig,
    schema,
    widget,
    widgetType,
    flags,
  }) => {
    if (!directiveConfig.enabled && !directiveConfig.semanticTag) {
      return schema;
    }

    if (
      flags[FormBuilderMetaFlags.SkipValidationRules] &&
      !flags[FormBuilderMetaFlagExportMetadata]
    ) {
      return schema;
    }

    // Salviamo il tipo del campo da esportare nei meta, così da accedervi
    // in fase di estrazione
    const directiveMetadata: IMetadataDirectiveSchemaMeta = {
      export: Boolean(directiveConfig.enabled),
      searchable: !!directiveConfig.searchable,
      type: schema.type,
      widgetId: widget.id,
      widgetType: widgetType.type,
      semanticTag: directiveConfig.semanticTag,
    };
    return schema.meta?.({
      directiveMetadata,
    });
  },
};
